<template lang="pug">
  v-container.pa-0(fluid)
    //- Dialogs
    //- .text-center
      //- Loading data
      // TO FIX : displays a infinite dialog
    //- v-dialog(v-model="isLoadingData" persistent="" width="300")
    //-   v-card(color="white" dark="")
    //-     v-card-text
    //-       | Por favor espere...
    //-       v-progress-linear.mb-0(indeterminate="" color="primary")
    //- Validate restrinctions
    v-dialog( persistent  :value='validatorRestrictions'  max-width='500px')
      div(style ='position:relative; height: 100%;')
        validate-restrictions(:data="dataValidator" @close="validatorRestrictions=false")
    v-dialog( persistent  :value='validatorRestrictionsStatus'  max-width='500px')
      div(style ='position:relative; height: 100%;')
        validate-restrictions(:data="dataValidatorStatus" @close="validatorRestrictionsStatus=false")
    //- Snackbar
    v-snackbar(v-model='snackbar.snackbar' :color='snackbar.color' :center="true" :timeout='snackbar.timeout' :top="true")
      | {{ snackbar.text }}
      v-btn(dark='' text='' @click='snackbar.snackbar = false')
        | {{$t('payment.general.close')}}
    //- Validate shop status
    v-dialog( persistent  :value='banShopStatus'  max-width='500px')
      div(style ='position:relative; height: 100%;')
        validate-restrictions(:data="dataValidator" @close="banShopStatus=false")
    //- create product
    v-dialog( fullscreen persistent  :value='createItemDialog' max-width='800px'   transition="dialog-bottom-transition")
      create-item( @close="createItemDialog=false" v-if='createItemDialog' )
    //- add first product
    v-dialog(persistent :value="showNoProductsDialog && !isLoadingData && !validatorRestrictions && !validatorRestrictionsStatus && !banShopStatus" max-width='400px' :retain-focus="false")
      v-card
        v-card-title.dialog-card-title
          p Agregar productos
          v-icon(color="white" aria-label="Close" @click="showNoProductsDialog = false") mdi-close
        v-card-text.body-1.text-center
          v-row
            v-col(cols="12" md="12")
              p {{shop.name + ' no tiene productos para vender.'}}
            v-col(cols="12" md="12")
              v-btn(color="primary" @click="createProductDialog = true") Crear un producto
    //- create product
    v-dialog( :fullscreen="isMobile" persistent  v-if='createProductDialog' v-model="createProductDialog" max-width='800px'   transition="dialog-bottom-transition")
      create-product(@close="createProductDialog = false" )
    //- delete store
    v-dialog(v-model='confirmationDialog' width="500px" persistent)
      v-card
        v-card-title
          | {{$t('shops.details.delete_store')}}
          v-spacer
            v-icon(aria-label="Close" @click="$emit('close')")
              | mdi-close
        v-card-text.body-1.text-center
          | {{$t('shops.details.delete_question')}}
        v-card-actions.text-center
          v-spacer
            v-btn(color='green darken-1', flat='', @click.native='confirmationDialog = false') {{$t('shops.details.no_answer')}}
            v-btn(color='red darken-1', flat='', :loading="loadingDeleteShop" @click.native='deleteItem()') {{$t('shops.details.yes_answer')}}
    //- Content
    v-app-bar(
      color="#6A76AB"
      dark
      shrink-on-scroll
      prominent
      height="100"
      :src="getImage(shop.pictures.imageInput1)"
      fade-img-on-scroll
      scroll-target="#scrolling-techniques-3"
    )
      template(v-slot:img="{ props }")
        v-img(v-bind="props" gradient="to top right, rgba(100,115,201,.7), rgba(25,32,72,.7)")
      //- v-btn(v-if="!loadingCover" text small color="success" @click="changeCoverPicture('imageInput1')").edit-btn
        v-icon mdi-pencil
      v-toolbar-title {{ shop.name }}
      //- Tabs options
      template(v-slot:extension="")
        v-tabs(v-model="currentItem" show-arrows slider-color="white")
          v-tab(v-for="item in items" :key="item" :href="'#tab-' + item" @click="selectCategory(item)")
            | {{ item | translate }}
    //- Tabs
    v-tabs-items(v-model="currentItem" style="background: transparent !important;")
      //- Shop details
      v-tab-item( key="details" value="tab-details")
        v-row.px-5
          v-col.pt-0(cols="12" xs="12" sm="12" md="6")
            ShopDetails
          v-col.pt-0(cols="12" xs="12" sm="12" md="6")
            v-container.px-1(fluid)
              Movements(title="Movimientos esta semana" :shop="shop.id" :showExpenses="false")
              v-row.pa-0
                v-col.pt-0.padding-bottom-mobile(cols="12" xs="12" sm="5" md="5")
                  ShopActions(:changeTab="true" @changeTab="changeTab")
                v-col.pt-0.padding-bottom-mobile(cols="12" xs="12" sm="7" md="7")
                  SummarySales(:shop="shop.id")
      //- Products
      v-tab-item.pb-10( key="inventory" value="tab-inventory")
        Products(v-if='currentItem === "tab-inventory"')
      //- Metrics
      v-tab-item.pb-2( key="metrics" value="tab-metrics")
        Summary(v-if='currentItem === "tab-metrics"' :shopId="shop.id" :startAtInventory="startAtInventory")
      //- Restaurant
      v-tab-item(key="restaurant" value="tab-restaurant")
        Restaurant(v-if='currentItem === "tab-restaurant"')
      //- Vitual Store
      v-tab-item( key="virtual-store" value="tab-virtual-store")
        VirtualShop(v-if='currentItem === "tab-virtual-store"' :shop="shop")
        //- v-card(v-if='currentItem === "tab-virtual-store"' flat="")
          v-sheet#scrolling-techniques-3.overflow-y-auto()
            v-container(fluid).pa-0
              v-flex(md12='')
                v-skeleton-loader.mx-auto(transition='scale-transition' v-if='!shop' max-width='300' type='card')
                // Menu
                v-row
                  // Menu
                  v-col(cols="12")
                    v-tabs(:vertical="!isMobile" v-model="menu" show-arrows)
                      v-tab(v-for="(item, i) in menus" :key="i" @click="settingUp")
                        v-icon(left="") {{item.icon}}
                        | {{item.title}}
                      // Guardar
                      // v-row()
                        v-col(style="text-align: center;")
                      v-layout.text-center
                        v-btn(v-if="!banActiveVirtualShop && !isMobile" color='success' :loading="loadingSaveVirtShop" :disabled="!location.lat || !location.lng || !txtAddress || loadingSubdomain || !validSubdomain || !subdomainVshop"  @click='saveVirtualShop()').mt-3
                          v-icon(small) mdi-content-save
                          | {{$t('shops.virtual_shop.save_virtual_shop')}}
                      v-tab-item
                        // Tienda virtual
                        v-card(flat="")
                          v-card-text(v-if="menu === 0 || !menu")
                            v-row
                              v-col(cols="12")
                                h3 {{menus[menu].title}}
                                v-card-text
                                  v-row.justify-start()
                                    v-col(cols="6")
                                      v-btn(v-if="virtualShopActive && virtualShop.subdomain" dark small color="primary" :href="`/#/shop/${virtualShop.subdomain}`" target="_blank").mr-2
                                        v-icon(color="white") mdi-share
                                        | Ir a la tienda virtual
                                    v-col(cols="6" v-if="virtualShop.subdomain").justify-end
                                      p.d-inline Compartir tienda virtual:
                                      ShareNetwork(
                                      v-for="network in networks"
                                      :network="network.network"
                                      :key="network.network"
                                      :url="sharing.url"
                                      :title="sharing.title"
                                      :description="sharing.description"
                                      :quote="sharing.quote"
                                      :hashtags="sharing.hashtags"
                                      ).mx-2
                                        v-icon(size="30" color="primary") {{network.icon}}
                                  v-row
                                    v-col(cols='12')
                                      // Direccion
                                      label(v-if="location.lat && location.lng") Dirección:
                                      label(v-if="location.lat && location.lng") {{txtAddress}}
                                      p(v-if="!location.lat || !location.lng" style="color: red;") No tienes una dirección guardada por favor ingresa una.
                                      // Switch
                                      v-switch(v-model="virtualShopActive" :disabled="inventoryLength" @change="activeVirtualShop($event)" :label='`${virtualShopActive ? "Desactivar tienda virtual" : "Activar tienda virtual"}`')
                                      small(v-if="inventoryLength" color="") Esta tienda debe tener al menos un producto para activar la tienda virtual
                                    v-row().d-flex
                                      v-col(cols="6").d-flex
                                        p.d-flex.align-center.pl-3() tenderapp.co/shop/
                                        v-text-field.ml-2(:label="virtualShop.subdomain ? 'Nombre de tu pagina web' :'Nombre para tu pagina web'" :rules="[rules.required, rules.subdomain]" :disabled="!!virtualShop.subdomain" v-model="subdomainVshop")
                                        v-btn.ml-2(color="primary" v-if="!virtualShop.subdomain" @click="verifySubdomain" :disabled="!subdomainVshop || !validateSubdomains" :loading="loadingSubdomain" style="margin-left: 20px !important;align-self: center;padding: 10px !important;") Validar nombre
                                      v-col.d-flex.align-center
                                        p.red--text(v-if="!virtualShop.subdomain && !validSubdomain && !loadingSubdomain && subdomainVshop && visibleText") Nombre no disponible. Por favor escoge otro.
                                        p.green--text(v-if="!virtualShop.subdomain && validSubdomain && !loadingSubdomain && subdomainVshop && visibleText") Nombre disponible
                                    v-col(cols="12")
                                      gmap-autocomplete(@place_changed="setPlace" :options="autocompleteOptions" class="border-location" placeholder="Introduce la dirección de la tienda").location-input
                                      gmap-map(:center="center" :zoom="zoom" style="width:100%;  height: 300px;" :options="option").mt-4
                                        gmap-marker(:key="index" v-for="(m, index) in markers" :animation="2" :position="m.position" :clickable="true" @click="openInfoWindow(m)")
                                        gmap-info-window(:options="infoOptions" :position="infoContent.position" :opened="infoWinOpen" @closeclick="infoWinOpen=false")
                      v-tab-item
                        v-card(flat="")
                          v-card-text(v-if="menu === 1")
                            ShopCMS(:shopForm="shopForm" :rangeShop="rangeShop")
    //- v-layout(wrap='' style="width: 100%; overflow-x: hidden;").pa-0
      v-col(v-if="!isMobile" cols='12' md='12').pa-0
          v-tabs-items(v-model="currentItem" style="background: transparent !important;")
            //- v-tab-item( key="promotions" value="tab-promotions")
              v-sheet#scrolling-techniques-3.overflow-y-auto
                v-card(v-if='currentItem === "tab-promotions"' flat="")
                  v-container(fluid).pa-0
                    v-flex(md12)
                      Promotions(:shop="shop")
            //- v-tab-item( key="orders" value="tab-orders")
              orders(:shop="shop")
            v-tab-item( key="virtual-store" value="tab-virtual-store")
              v-card(v-if='currentItem === "tab-virtual-store"' flat="")
                v-sheet#scrolling-techniques-3.overflow-y-auto()
                  v-container(fluid).pa-0
                    v-flex(md12='')
                      v-skeleton-loader.mx-auto(transition='scale-transition' v-if='!shop' max-width='300' type='card')
                      // Menu
                      v-row
                        // Menu
                        v-col(cols="12")
                          v-tabs(:vertical="!isMobile" v-model="menu" show-arrows)
                            v-tab(v-for="(item, i) in menus" :key="i" @click="settingUp")
                              v-icon(left="") {{item.icon}}
                              | {{item.title}}
                            // Guardar
                            // v-row()
                              v-col(style="text-align: center;")
                            v-v-layout.text-center
                              v-btn(v-if="!banActiveVirtualShop && !isMobile" color='success' :loading="loadingSaveVirtShop" :disabled="!location.lat || !location.lng || !txtAddress || loadingSubdomain || !validSubdomain || !subdomainVshop"  @click='saveVirtualShop()').mt-3
                                v-icon(small) mdi-content-save
                                | {{$t('shops.virtual_shop.save_virtual_shop')}}
                            v-tab-item
                              // Tienda virtual
                              v-card(flat="")
                                v-card-text(v-if="menu === 0 || !menu")
                                  v-row
                                    v-col(cols="12")
                                      h3 {{menus[menu].title}}
                                      v-card-text
                                        v-row.justify-start()
                                          v-col(cols="6")
                                            v-btn(v-if="virtualShopActive && virtualShop.subdomain" dark small color="primary" :href="`/#/shop/${virtualShop.subdomain}`" target="_blank").mr-2
                                              v-icon(color="white") mdi-share
                                              | Ir a la tienda virtual
                                          v-col(cols="6" v-if="virtualShop.subdomain").justify-end
                                            p.d-inline Compartir tienda virtual:
                                            ShareNetwork(
                                            v-for="network in networks"
                                            :network="network.network"
                                            :key="network.network"
                                            :url="sharing.url"
                                            :title="sharing.title"
                                            :description="sharing.description"
                                            :quote="sharing.quote"
                                            :hashtags="sharing.hashtags"
                                            ).mx-2
                                              v-icon(size="30" color="primary") {{network.icon}}
                                        v-row
                                          v-col(cols='12')
                                            // Direccion
                                            label(v-if="location.lat && location.lng") Dirección:
                                            label(v-if="location.lat && location.lng") {{txtAddress}}
                                            p(v-if="!location.lat || !location.lng" style="color: red;") No tienes una dirección guardada por favor ingresa una.
                                            // Switch
                                            v-switch(v-model="virtualShopActive" :disabled="inventoryLength" @change="activeVirtualShop($event)" :label='`${virtualShopActive ? "Desactivar tienda virtual" : "Activar tienda virtual"}`')
                                            small(v-if="inventoryLength" color="") Esta tienda debe tener al menos un producto para activar la tienda virtual
                                          v-row().d-flex
                                            v-col(cols="6").d-flex
                                              p.d-flex.align-center.pl-3() tenderapp.co/shop/
                                              v-text-field.ml-2(:label="virtualShop.subdomain ? 'Nombre de tu pagina web' :'Nombre para tu pagina web'" :rules="[rules.required, rules.subdomain]" :disabled="!!virtualShop.subdomain" v-model="subdomainVshop")
                                              v-btn.ml-2(color="primary" v-if="!virtualShop.subdomain" @click="verifySubdomain" :disabled="!subdomainVshop || !validateSubdomains" :loading="loadingSubdomain" style="margin-left: 20px !important;align-self: center;padding: 10px !important;") Validar nombre
                                            v-col.d-flex.align-center
                                              p.red--text(v-if="!virtualShop.subdomain && !validSubdomain && !loadingSubdomain && subdomainVshop && visibleText") Nombre no disponible. Por favor escoge otro.
                                              p.green--text(v-if="!virtualShop.subdomain && validSubdomain && !loadingSubdomain && subdomainVshop && visibleText") Nombre disponible
                                          v-col(cols="12")
                                            gmap-autocomplete(@place_changed="setPlace" :options="autocompleteOptions" class="border-location" placeholder="Introduce la dirección de la tienda").location-input
                                            gmap-map(:center="center" :zoom="zoom" style="width:100%;  height: 300px;" :options="option").mt-4
                                              gmap-marker(:key="index" v-for="(m, index) in markers" :animation="2" :position="m.position" :clickable="true" @click="openInfoWindow(m)")
                                              gmap-info-window(:options="infoOptions" :position="infoContent.position" :opened="infoWinOpen" @closeclick="infoWinOpen=false")
                            // Personalizacion
                            v-tab-item
                              v-card(flat="")
                                v-card-text(v-if="menu === 1")
                                  ShopCMS(:shopForm="shopForm" :rangeShop="rangeShop")
</template>

<script>
  import * as firebase from 'firebase'
  import loaders from '@/plugins/mixins/loaders'
  import CreateItem from './CreateShop'
  import CreateProduct from '@/views/custom/CreateProduct'
  import Promotions from '../custom/Promotions'
  import Orders from './transactions/Orders'
  import imageCompression from 'browser-image-compression'
  import moment from 'moment'
  import allCategorys from '@/assets/icons/products.png'
  // import * as vars from '@/vars.json'
  import ShopCMS from '@/views/custom/shops-content/ShopCMS'
  import addInventory from '@/assets/icons/home/proveedores.png'
  import goToPos from '@/assets/icons/home/creartienda.png'
  // import Requests from './transactions/Requests'
  // import {gmapApi} from 'vue2-google-maps'

  var geocoding = require('reverse-geocoding-google')
  var googleKey = 'AIzaSyDKCNiiLsmKRGo9E6UueE9sdZZArHJMJRU' // 'AIzaSyBS6_4xgnglXNo-pxeAJfmgOoGl3ZgdqGo'

  export default {
    components: {
      CreateItem: CreateItem,
      CreateProduct: CreateProduct,
      Promotions: Promotions,
      Orders: Orders,
      ShopCMS,
      // Requests: Requests,
      ValidateRestrictions: () => import('@/views/pages/components/ValidateRestrictions'),
      ShopDetails: () => import('@/components/custom/shops/Shops_Detail.vue'),
      ShopActions: () => import('@/components/custom/shops/Shop_Actions.vue'),
      Movements: () => import('@/components/custom/metrics/movement_summary'),
      SummarySales: () => import('@/components/custom/metrics/summary_transactions'),
      Restaurant: () => import('@/components/custom/shops/Restaurant'),
      Products: () => import('@/views/custom/Products'),
      Summary: () => import('@/views/dashboard/Dashboard'),
      VirtualShop: () => import('@/components/custom/shops/Shop_Virtual'),
    },
    filters: {
      translate (val) {
        switch (val) {
          case 'details':
            return 'detalles'
          case 'inventory':
            return 'inventario'
          case 'metrics':
            return 'metricas'
          case 'virtual-store':
            return 'Tienda virtual'
          case 'orders':
            return 'Ordenes'
          case 'promotions':
            return 'Promociones'
          case 'restaurant':
            return 'Configuración Restaurante'
        // case 'requests':
        //   return 'Pedidos'
        }
      },
      currencyDisplay: {
        read: function (val) {
          return '$' + val.toFixed(2)
        },
        write: function (val, oldVal) {
          var number = +val.replace(/[^\d.]/g, '')
          return isNaN(number) ? 0 : number
        },
      },
    },
    mixins: [loaders],
    data () {
      return {
        startAtInventory: false,
        rules: {
          required: value => !!value || 'Ingrese un nombre.',
          subdomain: value => {
            const pattern = /^[a-zA-Z]+$/
            return pattern.test(value) || 'Nombre invalido'
          },
        },
        addInventory,
        goToPos,
        loadingSubdomain: false,
        validSubdomain: false,
        visibleText: false,
        createProductDialog: false,
        loadingSaveVirtShop: false,
        isLoadingData: true,
        loadingTopProds: false,
        showNoProductsDialog: false,
        subdomainVshop: '',
        topSales: [],
        allCategorys: allCategorys,
        virtualShop: {
          id: '',
          name: '',
          address: '',
          addressgoogle: '',
          location: '',
          uid: '',
          img: '',
          categories: '',
          type: '',
          scope: '',
          mainCategorie: '',
          banner: '',
          colors: {
            primary: null,
            secondary: null,
          },
        },
        snackbar: {
          color: '',
          snackbar: false,
          text: '',
          timeout: 6000,
        },
        loadingDeleteShop: false,
        zoom: 16,
        center: { lat: 37.0902405, lng: -95.7128906 },
        markers: [],
        option: {
          zoomControl: true,
          mapTypeControl: true,
          scaleControl: true,
          streetViewControl: true,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: true,
        },
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35,
          },
        },
        infoContent: {
          position: '',
          data: {
            location: '',
          },
        },
        infoWinOpen: false,
        txtAddress: '',
        location: {
          lat: '',
          lng: '',
        },
        virtualShopActive: false,
        banShopStatus: false,
        dataValidator: {
          title: this.$t('shop.createModule.titleShopStatus'),
          message: this.$t('shop.createModule.messageValidatorShopStatus'),
        },
        dataValidatorStatus: {
          title: this.$t('shop.createModule.titleValiadtorShopStatus'),
          message: this.$t('shop.createModule.messageValidatorShopStatus'),
        },
        createItemDialog: false,
        confirmationDialog: false,
        validRoute: false,
        productListDialog: false,
        currentItem: 'tab-details',
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing',
        // items: ['details', 'inventory', 'metrics', 'promotions', 'virtual-store', 'orders'],
        // items: ['details', 'inventory', 'metrics', 'restaurant'],
        // more: ['mas'],
        metricUnits: ['Metros', 'Kilometros'],
        bannedProducts: [
          {
            img: 'http://placehold.it/500',
            name: 'product sample',
            stock: 10,
            inversion: 24,
            sell: 1000,
            utility: 'prueba',
            soldit: 'asdasdas',
          },
        ],
        headersBannedProducts: [
          { text: 'Imagen', value: 'pictures' },
          { text: 'Nombre', value: 'name' },
        ],
        headersExcludedList: [
          { text: 'Imagen', value: 'pictures' },
          { text: 'Nombre', value: 'name' },
          { text: 'Actions', value: 'action' },
        ],
        filterProduct: '',
        singleSelect: false,
        selected: [],
        shopMode: {
          marketplace: true,
          app: false,
        },
        shopForm: {
          description: '',
          domicileValue: 0,
          minOrderValue: 0,
        },
        rangeShop: 0,
        rangeShopDefine: 0,
        minSells: 294.32,
        virtualShopsRestriction: null,
        validatorRestrictions: false,
        validatorRestrictionsStatus: false,
        banActiveVirtualShop: false,
        menu: 0,
        menus: [
          { title: this.$t('shops.virtual_shop.menus_titles.virtual_store'), icon: 'mdi-account' },
          { title: this.$t('shops.virtual_shop.menus_titles.cms'), icon: 'mdi-folder' },
        ],
        itemMenu: '',
        imageRef: '',
        whichOne: '',
        loadingProfile: false,
        loadingCover: false,
        itemSelected: '',
        restaurentDialog: false,
      }
    },
    computed: {
      autocompleteOptions () {
        const country = this.$store.state.users.profile.direction && this.$store.state.users.profile.direction.country === 'México' ? 'mx' : 'co'
        return {
          componentRestrictions: {
            country: [
              country,
            ],
          },
        }
      },
      userId () {
        const userId = this.$store.state.users.user.adminUid ? this.$store.state.users.user.adminUid : this.$store.state.users.user.uid
        return userId
      },
      isMobile () {
        return window.innerWidth < 1024
      },
      excludedList () {
        return this.$store.state.shops.excludedList
      },
      loading () {
        return this.$store.getters['loading/getLoading']
      },
      shop () {
        const shop = this.$store.getters['shops/getCurrentItem']
        this.setDataShop(shop)
        return shop
      },
      inventoryLength () {
        if (!this.isLoadingData) {
          const temp = this.$store.getters['products/getAllItems']
            .filter(item => !!(item.location && item.location[this.shop.id]) && item.type !== 'ingredient') || []
          if (temp.length === 0) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      hotCategorie () {
        return this.$store.state.categories.currentItem
      },
      virtualShopSize () {
        return this.$store.state.shops.virtualShops.length
      },
      networks () {
        return [
          { network: 'facebook', name: 'Facebook', icon: 'mdi-facebook', color: '#1877f2' },
          { network: 'whatsapp', name: 'Whatsapp', icon: 'mdi-whatsapp', color: '#25d366' },
        ]
      },
      sharing () {
        return {
          url: `http://tenderstore.shop/vendor/${this.virtualShop.subdomain}`,
          title: this.shop.name,
          description: this.shop.description,
          quote: 'Visita la tienda virtual',
          hashtags: 'tendershop',
        }
      },
      itemsList () {
        return [
          { title: 'Ir al punto de Venta', icon: 'mdi-share' },
          { title: 'Detalles', icon: 'mdi-account' },
          { title: 'Inventario', icon: 'mdi-wallet-giftcard' },
          { title: 'Metricas', icon: 'mdi-wallet-giftcard' },
          { title: 'Restaurant', icon: 'mdi-store' },
          // { title: 'Promociones', icon: 'mdi-wallet-giftcard' },
          /* { title: 'Tienda Virtual', icon: 'mdi-wallet-giftcard' }, */
          // { title: 'Ordenes', icon: 'mdi-wallet-giftcard' },
        ]
      },
      validateSubdomains () {
        const vm = this
        return /^[a-zA-Z]+$/.test(vm.subdomainVshop)
      },
      items () {
        // items: ['details', 'inventory', 'metrics', 'promotions', 'virtual-store', 'orders'],
        const itemsTab = ['details', 'inventory', 'metrics', 'virtual-store']
        const shop = this.$store.getters['shops/getCurrentItem']
        if (shop && shop.mainCategorieSelect && shop.mainCategorieSelect.data === 'Restaurantes') {
          itemsTab.push('restaurant')
        }
        return itemsTab
      },
    // get all products
    /* getCurrentShopItems () {
      return this.$store.getters['products/getCurrentShopItems']
    }, */
    },
    watch: {
      subdomainVshop (newVal, oldVal) {
        if (!newVal) {
          this.validSubdomain = false
          this.visibleText = false
        }
      },
      inventoryLength (newVal, oldVal) {
        if (newVal) {
          this.showNoProductsDialog = true
        } else {
          this.showNoProductsDialog = false
        }
      },
      virtualShopActive (val) {
        // console.log(val)
        if (val) {
          this.rangeShop = this.rangeShopDefine
        } else {
          this.rangeShop = 0
        }
      },
      shop (val) {
        const vm = this
        vm.$store.dispatch('shops/loadExcludedProducts')
        vm.$store.dispatch('shops/loadStats')
      },
      $route (to, from) {
        const vm = this
        if (vm.$route.params.id && vm.$route.params.id !== 'create') {
          vm.validRoute = true
          vm.$store.dispatch('shops/setCurrentItem', vm.$route.params.id)
          vm.$store.dispatch('summary/setCurrentShop', vm.shop)
        }
      },
      menu (newVal, oldVal) {
        const vm = this
        if (newVal === 2) {
          vm.loadingTopProds = true
          const info = {
            dates: {
              from: moment().subtract(29, 'days').format('YYYY-MM-DD'),
              to: moment().add(1, 'days').format('YYYY-MM-DD'),
            },
            userId: vm.$store.state.users.user.uid,
            shopId: vm.shop.id,
            context: '',
          }
          this.$store.dispatch('summary/top20Products', info).then(res => {
            vm.loadingTopProds = false
            // console.log('prodstop20', res)
            if (res) {
              vm.topSales = res
            } else {
              vm.topSales = []
            }
          })
        }
      },
    },
    created () {
      /* const vm = this
      vm.loadLocations()
      vm.$store.dispatch('shops/getVirtualShopUserList')
      if (vm.$route.params.metrics) {
        vm.selectItem(2)
        vm.currentItem = 'tab-metrics'
        vm.startAtInventory = true
      } else {
        vm.currentItem = 'tab-details'
        vm.startAtInventory = false
      } */
    },
    mounted () {
      // this.geolocate()
      // this.loadProducts()
      const vm = this
      vm.isLoadingData = true
      vm.$store.dispatch('products/loadItems', 'inventory').then(() => {
        // console.log('se cargaron los productos')
        this.isLoadingData = false
      }, function (err) {
        console.log(err, 'Permision denied error')
      })
      if (vm.$route.params.id) {
        vm.$store.dispatch('shops/setCurrentItem', vm.$route.params.id)
        vm.$store.dispatch('shops/loadStats')
        if (vm.shop) {
          vm.$store.dispatch('shops/loadExcludedProducts')
        }
      }
    },
    methods: {
      changeTab (tab) {
        this.currentItem = 'tab-' + tab
      },
      changeProfilePicture (ref) {
        this.whichOne = 'Profile'
        this.$refs[ref].click()
        this.imageRef = ref
      },
      changeCoverPicture (ref) {
        this.whichOne = 'Cover'
        this.$refs[ref].click()
        this.imageRef = ref
      },
      async handleImageUpload (event) {
        const vm = this
        const imageFile = event.target.files[0]
        // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
        // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)
        const options = {
          maxSizeMB: 0.5,
          useWebWorker: true,
          maxIteration: 15,
        }
        if (vm.whichOne !== 'Cover') {
          options.maxWidthOrHeight = 200
          this.loadingProfile = true
        } else {
          this.loadingCover = true
        }

        try {
          // console.log(imageFile.size / 1024 / 1024)
          if (imageFile.size / 1024 / 1024 < 0.5) {
            // console.log('original does not need compression')
            await vm.uploadToServer(imageFile)
          } else {
            const compressedFile = await imageCompression(imageFile, options)
            // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
            // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
            if (imageFile.size > compressedFile.size) {
              // console.log('compressed is smaller')
              await vm.uploadToServer(compressedFile)
            } else {
              // console.log('original is smaller')
              await vm.uploadToServer(imageFile)
            } // if original is smaller
          }
        } catch (error) {
          // console.log(error)
        }
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        const metadata = {
          contentType: file.type,
          customMetadata: {
            targetType: file.type,
            targetId: vm.shop.id,
            targetName: vm.shop.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        let input
        if (vm.whichOne === 'Profile') {
          input = 'imageInput1'
        } else {
          input = 'imageInput2'
        }
        storageRef.child(`users/${vm.shop.ownerId}/shops/pictures/${vm.shop.id}/${input}`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            // console.log(url)
            vm.$store.dispatch('shops/saveImage', { whichOne: vm.whichOne, url }).then(() => {
              if (vm.whichOne === 'Profile') {
                vm.shop.pictures.imageInput1 = url
                vm.loadingProfile = false
              } else {
                vm.shop.pictures.imageInput2 = url
                if (vm.virtualShopActive) {
                  const virtualShop = {
                    id: vm.shop.id,
                    img: vm.shop.pictures,
                  }
                  vm.$store.dispatch('shops/saveVirtualShopImage', virtualShop)
                }
                vm.loadingCover = false
              }
            })
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      selectCategory (item) {
        const vm = this
        if (item === 'virtual-store' && vm.hotCategorie.name !== 'HOT') {
          vm.settingUp()
          vm.$store.dispatch('products/setQuery', '')
          vm.$store.dispatch('categories/setCurrentItem', { name: 'HOT', type: 'default' })
        } else if (item !== 'virtual-store' && vm.hotCategorie.name === 'HOT') {
          vm.$store.dispatch('products/setQuery', '')
          vm.$store.dispatch('categories/setCurrentItem', { name: 'ALL', type: 'default' })
        }
      },
      activeVirtualShop (event) {
        const vm = this
        if (event) {
          vm.$store.dispatch('users/getRestrictions').then(res => {
            // console.log(res)
            if (res) {
              vm.virtualShopsRestriction = res.restrictions.virtualShops
              vm.status = res.status.val
              if (vm.status !== 'active') {
                vm.validatorRestrictionsStatus = true
                vm.banActiveVirtualShop = true
              }
              if (vm.virtualShopsRestriction === null) {
                vm.validatorRestrictions = true
                vm.banActiveVirtualShop = true
              }
              /* if (vm.virtualShopsRestriction <= vm.virtualShopSize) {
                vm.validatorRestrictions = true
                vm.banActiveVirtualShop = true
              } */
            } else {
              vm.validatorRestrictions = true
              vm.banActiveVirtualShop = true
              vm.virtualShopActive = false
            }
          }, rej => {
            vm.setDataNotification(true, 'error', vm.$t('shop.createModule.errorGetRestriction'))
          })
        }
      },
      verifySubdomain () {
        // console.log(this.virtualShop)
        // console.log(this.subdomainVshop)
        this.validSubdomain = false
        this.loadingSubdomain = true
        this.visibleText = false
        const regexsubdomain = /^[a-zA-Z]+$/.test(this.subdomainVshop)
        /* if (this.subdomainVshop) {
          this.validSubdomain = true
          // console.log('dsfdsf')
        } else */
        // console.log('the validation', regexsubdomain)
        if (regexsubdomain) {
          // console.log('dsfdsf')
          this.$store.dispatch('shops/validSubdomain', this.subdomainVshop).then(res => {
            this.loadingSubdomain = false
            // console.log('sdfdsf')
            if (res === 'ocupado') {
              this.validSubdomain = false
            } else if (res === 'libre') {
              this.validSubdomain = true
            }
            this.visibleText = true
          })
        } else {
          this.loadingSubdomain = true
          this.validSubdomain = false
          this.visibleText = true
        }
      },
      saveVirtualShop () {
        // console.log(this.shop)
        this.loadingSaveVirtShop = true
        const sendShop = this.shop
        let mainCategori = {}
        if (sendShop.mainCategorieSelect) {
          mainCategori = sendShop.mainCategorieSelect
        } else {
          mainCategori = {
            id: 'cat20',
            data: 'Otro',
          }
        }
        this.virtualShop = {
          id: sendShop.id,
          name: sendShop.name,
          address: sendShop.address,
          addressgoogle: this.txtAddress,
          location: this.location,
          uid: null,
          img: sendShop.pictures ? sendShop.pictures : '',
          categories: sendShop.categories || [],
          type: this.shopMode,
          status: this.virtualShopActive ? 'active' : 'inactive',
          scope: this.rangeShop,
          mainCategorie: mainCategori,
          subdomain: this.subdomainVshop.toLowerCase(),
          // topSales: this.topSales,
          ...this.shopForm,
        }
        this.$store.dispatch('shops/createVirtualShop', this.virtualShop).then(res => {
          if (res) {
            // console.log(res)
            this.virtualShop.subdomain = this.subdomainVshop
            this.setDataNotification(true, 'success', this.$t('payment.message.successProcess'))
            this.loadingSaveVirtShop = false
          }
        })
      },
      setDataNotification (ban, color, text) {
        this.snackbar.snackbar = ban
        this.snackbar.color = color
        this.snackbar.text = text
      },
      setPlace (place) {
        // console.log(place)
        const vm = this
        this.txtAddress = place.formatted_address
        vm.location = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        vm.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        this.markers = []
        this.markers.push({ position: vm.center })
      },
      setPlaceVirtualShop (place) {
        // console.log(place)
        const vm = this
        vm.location = {
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
        }
        vm.center = {
          lat: place.geometry.location.lat,
          lng: place.geometry.location.lng,
        }
        this.markers = []
        this.markers.push({ position: vm.center })
      },
      geolocate () {
        const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          vm.location = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          vm.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          this.markers = []
          this.markers.push({ position: vm.center })
          // gmapApi.geocoder.geo
          const config = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            key: googleKey,
          }
          geocoding.location(config, (err, data) => {
            if (err) {
              // console.log(err)
            } else {
              // console.log(data)
              this.txtAddress = data.results[0].formatted_address
            }
          })
        })
      },
      setDataShop (shop) {
        const vm = this
        // console.log(shop)
        try {
          let shopId = shop.id || null
          if (!shopId) { shopId = vm.$route.params.id }
          this.$store.dispatch('shops/getVitualShop', shopId).then((res) => {
            // console.log(res[0])
            if (res.length > 0) {
              if (res[0].data.status === 'active') {
                vm.virtualShopActive = true
              } else {
                vm.virtualShopActive = false
              }
              this.virtualShop = res[0].data
              this.subdomainVshop = res[0].data.subdomain || ''
              this.validSubdomain = !!res[0].data.subdomain
              this.txtAddress = res[0].data.addressgoogle
              this.rangeShop = res[0].data.scope
              this.rangeShopDefine = res[0].data.scope
              // form shop
              this.shopForm = {
                description: res[0].data.description,
                domicileValue: res[0].data.domicileValue,
                minOrderValue: res[0].data.minOrderValue,
              }
              const place = {
                geometry: {
                  location: res[0].data.location,
                },
              }
              this.setPlaceVirtualShop(place)
            } else {
              this.virtualShopActive = false
              this.subdomainVshop = ''
              this.validSubdomain = false
            }
          })
          if (shop.status) {
            if (shop.status.val !== 'active') {
              this.banShopStatus = true
            }
          }
        } catch (err) {
          // console.log(err)
        }
      },
      stock () {
        return 'location'
      },
      openDeleteDialog (id) {
        const vm = this
        vm.confirmationDialog = true
      },
      deleteItem () {
        const vm = this
        vm.loadingDeleteShop = true
        vm.$store
          .dispatch('shops/deleteItem', vm.shop)
          .then(function () {
            // console.log('eliminada')
            vm.confirmationDialog = false
            vm.loadingDeleteShop = false
            vm.$router.push('/dashboard')
          })
          .catch(function (err) {
            console.log(err)
            vm.loadingDeleteShop = false
            vm.confirmationDialog = false
            vm.dialog = false
          })
      },
      deleteExcludedProduct (id) {
        console.info('vas a eliminar este producto?: ', id)
        this.$store.dispatch('shops/deleteExcludedItem', id)
      },
      excludingProducts () {
        this.productListDialog = false
        this.$store.dispatch('shops/excludedProducts', this.selected)
      },
      settingUp () {
        const distance = this.rangeShop
        const shopMode = this.shopMode
        const minSells = this.minSells
        this.$store.dispatch('shops/settingUpCurrentShop', { distance, shopMode, minSells })
      },
      price_format (price) {
        return new Intl.NumberFormat('nl-NL').format(price)
      },
      selectItem (index) {
        if (index === 0) {
          window.open(this.storeLink, '_blank')
        } else {
          this.itemSelected = index
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .padding-bottom-mobile{
    padding-bottom: 70px !important;
  }
  .main-shop-container{
    .app-bar-container{
      height: 300px !important;
    }
  }
  .v-slide-group__wrapper {
    overflow-x: auto !important;
  }
.border-location {
  width: 100%;
  border-bottom: solid;
  border-width: 1px;
  border-color: gray;
  margin: 0px !important;
  height: 30px;
  margin-top: 0px !important;
}
.edit-btn{
  position: absolute;
  z-index: 9999;
  right: 20px;
  top: 20px;
}

// estilos de topProds
$main-purple: #7957d5;
$secondary-purple:#DED4F8;
$main-color: #3cbbc2;
$main-blue: #108bc2;
$nav-color:  rgba(0, 158, 169, 0.54);
$content-bg: #ecedef;
$content-bg-transparent: rgba(#ecedef,0.7);
//navbar
$navbar-mobile-height: 80px;
$card-height: 152px;
$card-width: 130px;
$out-of-stock-color: #9d0707;

.wine-container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  // min-height: 290px;
  max-height: 370px;
  // overflow-x: auto;
  // overflow-y: hidden;
  padding: 0 5px;
  position: relative;
  align-content: flex-start;
  /* @include break-up('tablet'){

    max-height: 630px;
    flex-direction: row;
    overflow: auto;
  } */
  &.cart-container {
    // overflow: auto;
    max-height: unset;
  }
  .wine-card, .product-card {
    display: flex;
    position: relative;
    max-height: $card-height;
    height: $card-height;
    max-width: $card-width;
    border-radius: 10px;
    overflow: hidden;
    background-color: white;
    padding: 0;
    margin: 5px;
    flex: 1;
    transition: .3s;

    .card-image {
      align-items: center;
      justify-content: center;
      display: flex;
    }

    .card-content {
      padding: 0;
      background: rgba(#000, 0.7);
      color: #fff;
      font-size: 9px;
      font-weight: bold;
      z-index: 1;
      position: relative;
      bottom: 0;
      margin-top: auto;
      flex: 1;
      max-height: 50px;
      @media (min-width: 768px) {
        font-size: 10px;
      }
      .card-description {
        padding: 5px;
      }
    }
    .card-background {
      position: absolute;
      width: 100%;
      height: 100%;

      z-index: 0;
      img {
        z-index: 0;
        height: 100%;
        width: 100%;
        object-fit: contain;

      }
    }
  }
  .product-card {
    flex-direction: column;
    min-height:$card-height;
    max-height:$card-height;
    min-width: $card-width;

    box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.2);

    overflow: hidden;
    transition: .3s;
    user-select: none;

    &__content {
      display: flex;
      flex-direction: row;

    }
    &__left, &__right {
      display: flex;
      flex-direction: column;

    }
    &__left {
      align-items: center;
      width: calc(100% - 35px);
    }
    &__right {
      min-width: 35px;
      margin-left: auto;
    }
    &__tag {
      line-height: 10px;
      border-bottom: 1px dotted rgba(#000, 0.4);
      padding: 5px;
      text-align: center;
      font-size: 10px;
      font-weight: 500;
      position: relative;
      z-index: 0;
      min-height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before, &:after {
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        background: #d2d3d5;
        bottom: -4px;
        border-radius: 50%;
        z-index: 1;

      }
      &:before {
        left: -4px;
      }
      &:after {
        right: -4px;
      }
    }

    &__stock {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 5px 2px;
      border-radius: 4px;
      margin: 10px 5px 5px;
      background: $content-bg;
      &--out{
        background: $out-of-stock-color;
        color: #fff;
      }
      span {
        font-size: 10px;
      }
      p {
        font-size: 22px;
        font-weight: bold;

      }

    }
    &__background {
      padding: 5px 5px 0;
      position: relative;
      text-align: center;
      img {
        height: 60px;
        object-fit: contain;
      }
    }
    &__money-tag {
      color: $main-color;
      font-size: 18px;
      font-weight: 800;
    }
    &__description {
      display: flex;
      justify-content: center;
      flex-direction: row;
      flex-wrap: nowrap;
      text-align: left;
      padding: 0 3px !important;
      margin: 8px;

      p {
        font-size: 18px;
        font-weight: 800;
      }
    }
    &__addBtn{
      display: flex;
      justify-content: flex-end;
      margin-top: auto;
      width: 44px;
      position: absolute;
      right: 0;
      bottom: 0;
      transition: all 0.3s;
      &:hover{
        cursor:pointer;
        transform: scale(1.2);

      }

      &-container{
        width: 80px;
        height: 80px;
        margin-right: -40px;
        margin-bottom: -40px;
        background: $main-color;
        color: #ffF;
        border-radius: 50%;
        font-size: 30px;
        font-weight: 800;
        padding-left: 13px;

      }
      &--out{
        .product-card__addBtn-container{
          background: $out-of-stock-color;
        }

        img{
          width: 20px;
          height: 20px;
        }
      }
      span{

      }
    }
    .card-content {
      display: flex;
      max-height: 50px;
      min-height: 50px;
    }
    &--animated{
      &:hover {
        -webkit-animation: pulse .3s;
        animation: pulse .3s;
      }
    }
    &--full{

      max-width: 300px;
      width: 100%;
      min-width: 250px;

      .product-card__left{
        justify-content: center;
        align-items: center;
      }
      .product-card__left,  .product-card__right{
        flex:1;
      }
      .product-card__stock{
        margin: 0;
        padding: 0;
        flex-direction: row;
        flex-wrap: nowrap;
        // background: transparent;
        span,p{
          font-size: 12px;
        }
        p{
          margin-left: 5px;
        }
      }
      .product-card__background{
        text-align: center;
        img{
          height: 100px;
          object-fit: contain;
        }
      }
      .product-card__description{
        margin: 0;
        color : $main-color;

      }
    }
  }
}

.shop {
  &__title {
    text-align: center;
    color:#30b5bb;
    padding-top: 3.5rem;
    margin-top: 3.5rem;
    font-size: 2rem;

    &--detail {
      color:#a3a4a5;
      padding-top: 0;
      margin-top: 0;
      margin-bottom: 1rem;
    }
  }

  &__underline {
    position: relative;

    &:after {
      content:' ';
      position: absolute;
      top:100%;
      left:50%;
      width: 6rem;
      border:2px solid #30b5bb;
      border-radius:4px;
      transform:translateX(-50%);
    }
  }

  &__img {
    position: absolute;
    width: 8rem;
    height: 8rem;
    border-radius: 50% !important;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.shop-detail {
  border-radius: 5px;
  border-top-left-radius: 75px;
  background: #fff;

  &__img {
    margin: .8rem 0 0 .8rem;

    border-radius: 50%;
    height: 6rem;
    width: 6rem;
    object-fit: cover;
  }
}

.btn {
  // border: #000 solid 1px;
  background: #e4e4e4;
  border-radius: 5px;
  margin: .5rem;
  padding: .5rem;

  &__img {
    height: 3rem;
  }

  &__text {
    display: inline-block;
    color: #646464;
  }
}

</style>
